import { updateAddressUseCase } from '@src/main/modules/messages/application/use-cases/update/update-address.usecase';
import { UpdateAddressRequest } from '@src/main/modules/messages/infrastructure/dto/updateAddressRequest';
import { createAddressHttpRepository } from '@src/main/modules/messages/infrastructure/repository/AddressHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useUpdateAddress = () => {
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createAddressHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async (data: UpdateAddressRequest) => {
      if (!repository) throw new Error('Repository not initialized');
      return await updateAddressUseCase(data, tokenProvider);
    },
  });
};
